import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "dateTime" })
export class DateTimePipe implements PipeTransform {
  transform(value: string, format = "dd mmm at hh:mm"): string {
    const date = new Date(value);

    if (format === "dd mmm yy at hh:mm") {
      return `${date.getDate()} ${this.getMonth(
        date.getMonth(),
      )} ${this.getYear(date)} at ${this.getHours(date)}`;
    }

    // dd mmm at hh:mm
    return `${date.getDate()} ${this.getMonth(
      date.getMonth(),
    )} at ${this.getHours(date)}`;
  }

  getMonth(month: number) {
    if (month === 0) {
      return "Jan";
    } else if (month === 1) {
      return "Feb";
    } else if (month === 2) {
      return "Mar";
    } else if (month === 3) {
      return "Apr";
    } else if (month === 4) {
      return "May";
    } else if (month === 5) {
      return "Jun";
    } else if (month === 6) {
      return "Jul";
    } else if (month === 7) {
      return "Aug";
    } else if (month === 8) {
      return "Sep";
    } else if (month === 9) {
      return "Oct";
    } else if (month === 10) {
      return "Nov";
    } else if (month === 11) {
      return "Dec";
    }
    return "";
  }

  getHours(date: Date) {
    let isPM = false;
    let hour = date.getHours();
    if (hour >= 12) {
      isPM = true;
      if (hour > 12) {
        hour = hour - 12;
      }
    }

    let minutes = date.getMinutes().toString();
    if (minutes.length < 2) {
      minutes = `0${minutes}`;
    }

    return `${hour}:${minutes}${isPM ? "pm" : "am"}`;
  }

  getYear(date: Date) {
    return date.getFullYear().toString().substr(-2);
  }
}
